module.exports = __webpack_public_path__ + "img/user.f33e9fd1.png";